import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withI18next } from 'lib/i18n/withI18next'
import Utils from 'lib/utils'
import { loadKlinkScript } from 'lib/utils/klink'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import Icon from 'components/common/icon'
import ICONS from 'components/common/icon/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'

export async function onClickKlinkChat(user) {
  await loadKlinkScript(user)
  Utils.showChat()
}

const KlinkChatCTA = ({ t, user }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    if (isLoading) {
      return
    }

    setIsLoading(true)
    await onClickKlinkChat(user)
    setIsLoading(false)
  }

  return (
    <div
      data-cy="pdp__freshchat"
      className="pdp__freshchat"
      role="button"
      onClick={handleClick}
      onKeyDown={handleClick}
      tabIndex="0"
    >
      <Button type={BUTTON_TYPES.link} className="title">
        {isLoading ? (
          <span
            className="pdp__freshchat-loader"
            data-cy="pdp__freshchat-loader"
          />
        ) : (
          <Icon src={ICONS.supportChatBlack} />
        )}
      </Button>
      <span className={Typo.caption}>
        {hasLocizeTranslation(t, 'CHAT', 'CHAT')}
      </span>
    </div>
  )
}

KlinkChatCTA.defaultProps = {
  user: null,
}

KlinkChatCTA.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id_customer: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
}

const Extended = withI18next()(KlinkChatCTA)

export default connect((state) => ({
  user: state.auth.user,
}))(Extended)
